import { Text } from 'react-native'

import { formatRemainingTime, getRemainingTime } from '@/utils/formatter'
import { useAutomaticCountdown } from '@/hooks/useCountdown'

function RemainingTimeCountdown({ time, constraint }: { time: string | null; constraint: number }) {
  const { countdown: remainingTime } = useAutomaticCountdown({ startTime: getRemainingTime(time, constraint) })

  return <Text className={'font-roboto-medium text-sm text-text-info'}>{formatRemainingTime(remainingTime)}</Text>
}

export default RemainingTimeCountdown
